import { Grid, Box, Typography } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { useDialogContext } from '../../components/dialog-context';
import { services } from './services';
import Layout from '../../components/layout';
import { useTrigger } from '../../components/useTrigger';
import { useToastContext } from '../../components/toast-context';
import CurrentPrice from '../../components/current-price';
import PreviewPrice from '../../components/preview-price';
import SalesAndBuyback from '../../components/SalesAndBuyback';
import Treasury from '../../components/treasury';
import SaleTransactions from '../../components/sale-transactions';
import { cutDigitFromRight } from '../../utils';
import ComparisonChart from '../../components/comparision-chart';
import BuybackTransactions from '../../components/buybackTransactions';
import AverageSellPrice from '../../components/averageSellPrice';

import GeneralSellAndBuybackSetting from './GeneralSellAndBuybackSetting';
import { bullionTypes as bullionTypeList } from '../../core-bullions/bullions-core-config';

export const getprofitPercentage = bullionData => {
  let profitPercentage = null;
  let profitPercentageVariable = null;

  if (bullionData?.strategy === 'MANUAL') {
    profitPercentage = bullionData.manualMarginPercentage;
    profitPercentageVariable = 'manualMarginPercentage';
  } else if (bullionData?.strategy === 'AUTOMATIC_COMPETITOR') {
    profitPercentage = bullionData.differenceWithCompetitorPercentage;
    profitPercentageVariable = 'differenceWithCompetitorPercentage';
  } else if (bullionData?.strategy === 'AUTOMATIC_ESTJT') {
    profitPercentage = bullionData.estjtProfitPercentage;
    profitPercentageVariable = 'estjtProfitPercentage';
  }

  return { profitPercentage, profitPercentageVariable };
};

function SellPage() {
  const [showPreview, setShowPreview] = React.useState(false);
  const [bullionsConfig, setBullionsConfig] = React.useState([]);
  const [manualBullionsConfig, setManualBullionsConfig] = React.useState([]);
  const [isPriceFirstLoading, setIsPriceFirstLoading] = React.useState(true);

  const [currentStratgy, setCurrentStratgy] = React.useState('');
  const [estjPrices, setEstjPrices] = React.useState();
  const { trigger, trig } = useTrigger();
  const [competitorPrice, setCompetitorPrice] = useState(null);
  const [changedPreviewProductConfig, setChangedPreviewProductConfig] =
    React.useState([]);
  const [configValues, setConfigValues] = React.useState();

  useEffect(() => {
    if (configValues?.strategy !== 'MANUAL') {
      setShowPreview(false);
    }
  }, [
    configValues?.strategy,
    configValues?.costPercentage,
    configValues?.manualBasePrice,
  ]);

  useEffect(() => {
    services.get995Price().then(prices => {
      setPrices(prices);
      setIsPriceFirstLoading(false);
    });
  }, [trigger]);
  useEffect(() => {
    services.getEstjPrices().then(prices => {
      setEstjPrices(prices);
    });
  }, [trigger]);

  useEffect(() => {
    services.getProductsConfig({}).then(data => {
      setBullionsConfig(data || []);
    });
  }, [currentStratgy, trigger]);

  useEffect(() => {
    services.getProductsConfig({ strategy: 'MANUAL' }).then(data => {
      setManualBullionsConfig(data || []);
    });
  }, [currentStratgy, trigger]);

  useEffect(() => {
    services.getCompetitorPrices().then(data => setCompetitorPrice(data));
  }, [trigger]);

  const [rows, setRows] = React.useState([]);
  React.useEffect(() => {
    services.getInvoiceList().then(data => {
      data.sort(compare);
      setRows(data);
    });
  }, [trigger]);

  const [prices, setPrices] = React.useState({
    GB_999_1: { BUY: 0, BOARD: 0 },
    GB_999_2: { BUY: 0, BOARD: 0 },
    GB_999_5: { BUY: 0, BOARD: 0 },
    GB_999_10: { BUY: 0, BOARD: 0 },
    GB_999_20: { BUY: 0, BOARD: 0 },
    GB_999_50: { BUY: 0, BOARD: 0 },
    GB_999_100: { BUY: 0, BOARD: 0 },
    GB_995_1: { BUY: 0, BOARD: 0 },
    GB_995_2: { BUY: 0, BOARD: 0 },
    GB_995_5: { BUY: 0, BOARD: 0 },
    GB_995_10: { BUY: 0, BOARD: 0 },
    GB_995_20: { BUY: 0, BOARD: 0 },
    GB_995_50: { BUY: 0, BOARD: 0 },
    GB_995_100: { BUY: 0, BOARD: 0 },
  });

  const pricePerGram = estjPrices?.gold24k * 10;
  const manualPriceLessThanThreshhold = false;
  // (!!String(configValues?.manualBasePrice)?.includes(',')
  //   ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
  //   : Number(configValues?.manualBasePrice)) <=
  // Number(pricePerGram) * 0.99;
  const manualPriceMoreThanThreshhold = false;
  // (!!String(configValues?.manualBasePrice)?.includes(',')
  //   ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
  //   : Number(configValues?.manualBasePrice)) >=
  // Number(pricePerGram) * 1.1;
  const { openDialog, closeDialog } = useDialogContext();
  const { showToast } = useToastContext();

  const setProductConfig = async (rawData, productType) => {
    const { isPreview, ...data } = rawData;
    if (data?.data?.boardPrice <= data?.data?.price) {
      data.data.boardPrice = 0;
    }

    if (isPreview) {
      setChangedPreviewProductConfig(prev => {
        const isExisting = prev.findIndex(
          product => product.productType === productType
        );

        if (isExisting !== -1) {
          const updatedItems = [...prev];
          updatedItems[isExisting] = { ...data.data, productType };
          return updatedItems;
        }
        return [...prev, { ...data.data, productType }];
      });
      return;
    }

    try {
      const res = await services.setProductConfig({
        productType,
        ...data,
        transactionType: 'BUY',
      });
      if (res) {
        const theBullionIndex = bullionsConfig.findIndex(
          b => b.productType === productType
        );
        const theBullion = bullionsConfig[theBullionIndex];
        bullionsConfig.splice(theBullionIndex, 1);
        if (res.cutNumber || res.cutNumber === 0) {
          theBullion.cutNumber = res.cutNumber;
        }
        const currConfigProfitVariable =
          getprofitPercentage(res).profitPercentageVariable;

        if (
          res[currConfigProfitVariable] ||
          res[currConfigProfitVariable] === 0
        ) {
          theBullion[currConfigProfitVariable] = res[currConfigProfitVariable];
        }
        setBullionsConfig(rest => {
          return [...rest, theBullion];
        });
      }
      const changedBullions = changedPreviewProductConfig.reduce(
        (acc, curr, i) => {
          const theBullion = bullionTypes.find(
            bullion => bullion.key === curr.productType
          );

          if (
            changedPreviewProductConfig?.length === 1 ||
            i === changedPreviewProductConfig?.length - 1
          ) {
            return (acc += `${theBullion.name} `);
          }
          return (acc += `${theBullion.name} و `);
        },
        ''
      );

      showToast(` تنظیمات ${changedBullions} با موفقیت ثبت شد.`, 'success');
      setChangedPreviewProductConfig([]);
      closeDialog();
    } catch (error) {
      console.error('Error setting product config:', error);
      let toastMessage = 'خطایی رخ داده است.';
      if (error.response) {
        toastMessage =
          error.response.data?.message ||
          'خطایی در سرور رخ داد. لطفا دوباره تلاش کنید.';
      } else if (error.request) {
        toastMessage =
          'اتصال به اینترنت برقرار نیست. لطفاً شبکه خود را بررسی کنید.';
      } else {
        toastMessage = 'یک خطای غیرمنتظره در برنامه رخ داد.';
      }
      showToast(toastMessage, 'error');
    }
  };
  const bullionTypes = bullionTypeList({
    competitorPrice,
    bullionsConfig,
    pricePerGram,
    prices,
    configValues,
    manualBullionsConfig,
    changedPreviewProductConfig,
    setProductConfig,
  });

  const calculateManualPriceWithSideDishes = (productType, weight) => {
    const manualBasePrice = !!String(configValues?.manualBasePrice)?.includes(
      ','
    )
      ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
      : Number(configValues?.manualBasePrice);

    const manualBasePrice995 = (manualBasePrice / 999) * 995;

    const basePrice = productType.includes('GB_995')
      ? manualBasePrice995
      : manualBasePrice;

    const manualMarginPercentage =
      1 +
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.manualMarginPercentage?.toString() ||
          0
      ) /
        100;

    const cutNumber =
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.cutNumber?.toString()
      ) || 0;
    const calculatedPricewithPercentage = Math.floor(
      basePrice * manualMarginPercentage * weight
    );

    return cutDigitFromRight(calculatedPricewithPercentage, cutNumber);
  };

  const calculateManualBoardPriceWithSideDishes = (productType, weight) => {
    const manualBasePrice = !!String(configValues?.manualBasePrice)?.includes(
      ','
    )
      ? Number(configValues?.manualBasePrice?.replace(/,/g, ''))
      : Number(configValues?.manualBasePrice);

    const manualBasePrice995 = (manualBasePrice / 999) * 995;

    const basePrice = productType.includes('GB_995')
      ? manualBasePrice995
      : manualBasePrice;

    const manualMarginPercentage =
      1 +
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.manualMarginPercentage?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.manualMarginPercentage?.toString() ||
          0
      ) /
        100;

    const cutNumber =
      Number(
        changedPreviewProductConfig
          ?.find(product => product?.productType === productType)
          ?.cutNumber?.toString() ||
          manualBullionsConfig
            ?.find(b => b.productType === productType)
            ?.cutNumber?.toString()
      ) || 0;

    if (manualMarginPercentage < 1 && manualMarginPercentage !== 0) {
      const calculatedPriceWithoutDiscount = Math.floor(basePrice * weight);
      const res = cutDigitFromRight(calculatedPriceWithoutDiscount, cutNumber);
      if (res == calculateManualPriceWithSideDishes(productType, weight)) {
        return -1;
      }
      return res;
    } else if (manualMarginPercentage === 0) {
      return calculateManualPriceWithSideDishes(productType, weight);
    }
    return -1;
  };

  return (
    <>
      <GeneralSellAndBuybackSetting
        type={'BUY'}
        setShowPreview={setShowPreview}
        setConfigValues={setConfigValues}
        trig={trig}
        trigger={trigger}
        setCurrentStratgy={setCurrentStratgy}
      />
      <Box
        dir="rtl"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3,
        }}
      >
        <Grid
          pr={'0 !important'}
          container
          spacing={0}
          gap={3}
          justifyContent="center"
          alignItems="center"
          sx={{
            maxWidth: '1648px',
          }}
        >
          {showPreview && (
            <PreviewPrice
              pricePerGram={pricePerGram}
              manualBasePrice={configValues?.manualBasePrice}
              setShowPreview={setShowPreview}
              setProductConfig={setProductConfig}
              changedPreviewProductConfig={changedPreviewProductConfig}
              configValues={configValues}
              setBullionsConfig={setBullionsConfig}
              trig={trig}
              type={'BUY'}
              trigger={trigger}
              openDialog={openDialog}
              manualPriceLessThanThreshhold={manualPriceLessThanThreshhold}
              bullionTypes={bullionTypes}
              manualPriceMoreThanThreshhold={manualPriceMoreThanThreshhold}
            />
          )}

          <CurrentPrice
            pricePerGram={pricePerGram}
            rows={rows}
            setBullionsConfig={setBullionsConfig}
            bullionsConfig={bullionsConfig}
            trig={trig}
            trigger={trigger}
            manualPriceLessThanThreshhold={manualPriceLessThanThreshhold}
            manualPriceMoreThanThreshhold={manualPriceMoreThanThreshhold}
            bullionTypes={bullionTypes}
            isPriceFirstLoading={isPriceFirstLoading}
          />
        </Grid>
      </Box>
    </>
  );
}

export function downloadExportFile(data) {
  const todayData = data.filter(row => {
    return (
      new Date().valueOf() - new Date(row.createdAt).valueOf() <
      10 * 3600 * 1000
    );
  });

  const csvText =
    'id,partyName,partyPhoneNumber,partyNationalId,partyAddress,branch,createdAt,' +
    'bullion_1_count,bullion_1_price,' +
    'bullion_2_count,bullion_2_price,' +
    'bullion_5_count,bullion_5_price,' +
    'bullion_10_count,bullion_10_price,' +
    'bullion_20_count,bullion_20_price,' +
    'bullion_50_count,bullion_50_price,' +
    'bullion_100_count,bullion_100_price\n' +
    todayData
      .map(record => {
        const bullion_1 = record?.items?.find?.(
          item => item.type === 'GB_999_1'
        );
        const bullion_2 = record?.items?.find?.(
          item => item.type === 'GB_999_2'
        );
        const bullion_5 = record?.items?.find?.(
          item => item.type === 'GB_999_5'
        );
        const bullion_10 = record?.items?.find?.(
          item => item.type === 'GB_999_10'
        );
        const bullion_20 = record?.items?.find?.(
          item => item.type === 'GB_999_20'
        );
        const bullion_50 = record?.items?.find?.(
          item => item.type === 'GB_999_50'
        );
        const bullion_100 = record?.items?.find?.(
          item => item.type === 'GB_999_100'
        );
        return {
          id: record.id,
          partyName: record.partyName,
          partyPhoneNumber: record.partyPhoneNumber,
          partyNationalId: record.partyNationalId,
          partyAddress: record.partyAddress,
          branch: record.branch,
          createdAt: record.createdAt,
          bullion_1_count: bullion_1?.count ?? 0,
          bullion_1_price: bullion_1?.price?.value ?? 0,
          bullion_2_count: bullion_2?.count ?? 0,
          bullion_2_price: bullion_2?.price?.value ?? 0,
          bullion_5_count: bullion_5?.count ?? 0,
          bullion_5_price: bullion_5?.price?.value ?? 0,
          bullion_10_count: bullion_10?.count ?? 0,
          bullion_10_price: bullion_10?.price?.value ?? 0,
          bullion_20_count: bullion_20?.count ?? 0,
          bullion_20_price: bullion_20?.price?.value ?? 0,
          bullion_50_count: bullion_50?.count ?? 0,
          bullion_50_price: bullion_50?.price?.value ?? 0,
          bullion_100_count: bullion_100?.count ?? 0,
          bullion_100_price: bullion_100?.price?.value ?? 0,
        };
      })
      .map(v => Object.values(v).join(','))
      .join('\n');

  const element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/plain;charset=utf-8,' + encodeURIComponent(csvText)
  );
  element.setAttribute(
    'download',
    `خروجی(${new Date().toLocaleDateString('fa-IR', {
      dateStyle: 'short',
    })}).csv`
  );
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

function compare(a, b) {
  if (new Date(a.createdAt) < new Date(b.createdAt)) {
    return 1;
  }
  if (new Date(a.createdAt) > new Date(b.createdAt)) {
    return -1;
  }
  return 0;
}

export default SellPage;
